<template>
    <div class="doc_tabdiv">
        <div class="doctab_flex-div">
            <div class="doctab_textdiv">
                <img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/67a0fbc6b088c47594371247_icon_docbag.svg" alt="" class="image-550">
                <div class="doctab_toptextdiv">
                    <div class="text-block-1262">Doctor on Demand</div>
                    <div class="text-block-1263 mobile"><span class="text-span-277">Response time is less than 24 hours.</span><br>We will notify you by text when they respond.</div>
                </div>
                <div v-if="doctorProfile" class="doctor-profile-div">
                    <div class="div-block-1989">
                        <div class="doc_picdiv">
                            <img :src="doctorProfile.image || 'https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/674ed5635bcd4400903885e4_dr%20avatar.png'" loading="lazy" alt="Doctor profile">
                        </div>
                        <div class="doc_namediv">
                            <div class="text-block-1277">Dr. {{ doctorProfile.name || 'Loading...' }}</div>
                            <div class="doc_npi_div">
                                <div class="text-block-1278">NPI#:</div>
                                <div class="text-block-1279">{{ doctorProfile.npi || 'Loading...' }}</div>
                            </div>
                        </div>
                    </div>
                    <p class="paragraph-164">{{ doctorProfile.bio || 'Loading doctor profile...' }}</p>
                </div>
                <p class="paragraph-162">Use this chat to ask your doctor questions about your treatments, side effects and any other medical questions you may have.</p>
                <div class="text-block-1263 desk"><span class="text-span-277">Response time is less than 24 hours.</span><br>We will notify you by text when they respond.</div>
                <div class="div-block-1988">
                    <div class="text-block-1264">If you have billing, shipping, customer service, pharmacy or any other questions please click the button below</div>
                    <a href="#" class="button-125 w-button" @click.prevent="showChatWindow()">Chat with Customer Service</a>
                </div>
            </div>
            <div class="doctab_chat-div">
                <div class="w-embed">
                    <iframe src="https://patient.mdintegrations.com/tabs/messages?fullscreen=true" style="height:80vh; width: 100%; min-height: 450px;border: none;"></iframe>
                </div>
            </div>
        </div>
    </div>
    </template>
       
    <script>
    import { mapGetters } from 'vuex';
    
    export default {
        props: {
            baseUrl: {
                type: String,
                required: true
            }
        },
        
        data() {
            return {
                doctorProfile: null,
                loading: true,
                error: null
            }
        },
    
        computed: {
            ...mapGetters(['getCase', 'docProfile']),
        },
    
        watch: {
            // Watch for changes in case ID and provider
            getCase: {
                immediate: true,
                deep: true,
                handler(newCase) {
                    if (newCase && newCase.id && newCase.provider === 1) {
                        this.fetchDoctorProfile();
                    }
                }
            },
    
            // Watch for changes in docProfile from Vuex
            docProfile: {
                immediate: true,
                handler(newProfile) {
                    if (newProfile) {
                        this.doctorProfile = newProfile;
                        this.loading = false;
                    }
                }
            }
        },
    
        methods: {
            showChatWindow(){
                this.$root.$emit('toggle-chat');
            },
            async fetchDoctorProfile() {
                try {
                    this.loading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/get-doc-profile/${this.getCase.id}`);
                    if (response.data.status === 'success') {
                        const temp = response.data.case.case_assignment;
                        const doc = {
                            name: temp.clinician.full_name,
                            npi: temp.clinician.licenses[0].value,
                            bio: temp.clinician.bio_details,
                            image: temp.clinician.photo.url_thumbnail
                        };
                        await this.$store.dispatch('setDocProfile', doc);
                        this.doctorProfile = doc;
                    }
                } catch (error) {
                    this.error = 'Failed to load doctor profile';
                } finally {
                    this.loading = false;
                }
            }
        },
    
        async created() {
            // Check if we already have a profile in Vuex
            if (this.docProfile) {
                this.doctorProfile = this.docProfile;
                this.loading = false;
            } 
            // If we have a case ID but no profile, fetch it
            else if (this.getCase.id && this.getCase.provider === 1) {
                await this.fetchDoctorProfile();
            }
        }
    }
    </script>
<style>
@media screen and (max-width: 479px) {
    .doctab_flex-div {
        flex-flow: column;
    }
}
.doctab_flex-div {
    justify-content: space-between;
    padding-top: 50px;
    display: flex;
}
.doctab_textdiv {
    width: 35%;
}
.doctab_chat-div {
    border: 1px solid var(--f3-grey);
    width: 60%;
}
@media screen and (max-width: 479px) {
    .doctab_chat-div {
        border: 1px solid var(--f3-grey);
        width: 100%;
    }
}
@media screen and (max-width: 479px) {
    .doctab_textdiv {
        width: 100%;
        margin-bottom: 30px;
    }
}
@media screen and (max-width: 479px) {
    .image-550 {
        width: 35px;
        margin-bottom: 15px;
    }
}

.image-550 {
    width: 50px;
    margin-bottom: 30px;
}

@media screen and (max-width: 479px) {
    .doctab_toptextdiv {
        flex-flow: column;
        justify-content: space-between;
        display: flex;
    }
}
@media screen and (max-width: 479px) {
    .text-block-1262 {
        margin-bottom: 15px;
        font-size: 30px;
        line-height: 36px;
    }
}

.text-block-1262 {
    font-family: var(--mulish);
    color: var(--black);
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: 900;
    line-height: 36px;
}
@media screen and (max-width: 479px) {
    .text-block-1263.mobile {
        width: auto;
        font-size: 13px;
        line-height: 16px;
        display: none;
    }
}

.text-block-1263.mobile {
    display: none;
    overflow: visible;
}
.text-span-277 {
    font-weight: 900;
}
.doctor-profile-div {
    background-color: var(--f3-grey);
    border-radius: 9px;
    margin-bottom: 20px;
    padding: 20px;
}
.div-block-1989 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    display: flex
;
}
.doc_picdiv {
    background-color: var(--pastel-blue);
    border-radius: 100px;
    width: 50px;
    height: 50px;
    overflow: hidden;
}
.text-block-1277 {
    font-family: var(--inter);
    color: var(--black);
    margin-bottom: 3px;
    font-size: 14px;
    font-weight: 900;
}
.doc_npi_div {
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex
;
}
.text-block-1278 {
    font-family: var(--inter);
    color: var(--black);
    font-size: 13px;
    font-weight: 900;
    line-height: 15px;
}
.text-block-1279 {
    font-family: var(--inter);
    color: var(--black);
    font-size: 13px;
    line-height: 15px;
}
.paragraph-164 {
    color: var(--black);
    margin-bottom: 0;
    font-size: 12px;
    line-height: 15px;
}
.paragraph-162 {
    color: var(--black);
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 24px;
}
.text-block-1263.desk {
    font-size: 15px;
    line-height: 21px;
}

.text-block-1263 {
    color: var(--black);
    font-size: 18px;
    line-height: 24px;
}
.text-span-277 {
    font-weight: 900;
}
.div-block-1988 {
    background-color: var(--pastel-blue);
    margin-top: 30px;
    padding: 20px;
}
.text-block-1264 {
    font-family: var(--mulish);
    color: var(--white);
    margin-bottom: 20px;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
}
.button-125 {
    background-color: var(--black);
    font-family: var(--mulish);
    color: var(--white);
    text-align: center;
    border-radius: 9px;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 15px;
    font-weight: 600;
}
</style>
